import React from "react"
import ListCard from "../ListCard"
import "./TopPerformersCard.scss"

const TopPerformersCard = props => {
  return (
    <div className="TopPerformersCard">
      <ListCard dataSort="DESC" {...props}>
        <div className="icon" />
        Top Performers
      </ListCard>
    </div>
  )
}

TopPerformersCard.propTypes = {
  entityType: ListCard.propTypes.entityType,
  entityId: ListCard.propTypes.entityId,
}

export default TopPerformersCard
